/**
 * The legal anchor of the whole campaign feature — extracted to its own module so wizard
 * implementations can come and go without touching it.
 *
 * Rendered VERBATIM next to the consent checkbox and sent verbatim as `consentAttestationText`;
 * the server stores it as evidence (Israeli spam law — חוק התקשורת, Amendment 40). Never reword
 * the rendered copy without the stored one: they are the same string on purpose.
 */
export const CONSENT_ATTESTATION_TEXT =
  "אני מאשר/ת שכל הנמענים ברשימה נתנו את הסכמתם לקבל ממני הודעות, בהתאם לחוק התקשורת (בזק ושידורים), התשמ\"ב-1982, ושהאחריות על תוכן ההודעות ועל השליחה חלה עליי.";
